import { DateTime } from 'luxon';
import { formatDateRange } from '@la/utilities';
import styles from './RegistrationHeader.module.scss';

export type RegistrationHeaderProps = {
  teamName?: string;
  title?: string;
  tournamentEndDate?: DateTime;
  tournamentLocation?: string;
  tournamentName: string;
  tournamentStartDate: DateTime;
};

/* RegistrationHeader */
export function RegistrationHeader({
  teamName,
  title = 'Register',
  tournamentEndDate,
  tournamentLocation,
  tournamentName,
  tournamentStartDate,
}: Readonly<RegistrationHeaderProps>) {
  const tournamentDate = formatDateRange(
    tournamentStartDate,
    tournamentEndDate
  );

  return (
    <div className={styles.registrationHeader}>
      <div className={styles.pageTitle}>{title}</div>
      <div className={styles.tournamentData}>
        <span>{tournamentName}</span>
        <span className={styles.bullet}>&#8226;</span>
        {teamName ? (
          <>
            <span>{teamName}</span>
            <span className={styles.bullet}>&#8226;</span>
          </>
        ) : null}
        {tournamentLocation ? (
          <>
            <span>{tournamentLocation}</span>
            <span className={styles.bullet}>&#8226;</span>
          </>
        ) : null}
        <span>{tournamentDate}</span>
      </div>
    </div>
  );
}
